// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"659":"2620b92f","681":"b15b3f9a","702":"491b0215","899":"b2720243"}[chunkId] + ".chunk.js";
};